module.exports = __webpack_public_path__ + "static/img/sousuo1.40692e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sousuo1.png
// module id = Asb+
// module chunks = 1